<template>
  <div class="flex f-jcenter">
    <img src="../img/long.png" />
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
// studycollect
export default {
  name: "Learn",
  components: {},
  data() {
    return {};
  },

  created() {
    console.log("created----");
  },

  // 其他页面进来时更新初始数据
  activated() {
   
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);

    next();
  },

  methods: {

    toDetail(id = 1) {
      this.$router.push({
        path: "/Img",
        query: { id: id },
      });
      // this.$router.push({
      //   path: "/creation/detail",
      //   query: { id: id },
      // });
    }


  },
};
</script>
